import { LargeBadge, Info } from './styles'

const Badge = () => (
  <LargeBadge border='red' colour='red' size='large'>
    <Info />
  </LargeBadge>
)

export default Badge
